import * as React from "react"

import { cn } from "../../lib/utils"

// Input types that should NOT be uppercased
const NO_UPPERCASE_TYPES = ["password", "email", "url", "color", "file", "hidden", "number", "date", "datetime-local", "time", "month", "week", "range"];

const Input = React.forwardRef(({ className, type, onWheel, onFocus, onChange, ...props }, ref) => {
  const handleWheel = type === "number"
    ? (e) => { e.target.blur(); onWheel?.(e); }
    : onWheel;

  const handleFocus = type === "number"
    ? (e) => { e.target.select(); onFocus?.(e); }
    : onFocus;

  const shouldUppercase = !NO_UPPERCASE_TYPES.includes(type);

  const handleChange = shouldUppercase
    ? (e) => {
        const start = e.target.selectionStart;
        const end = e.target.selectionEnd;
        e.target.value = e.target.value.toUpperCase();
        e.target.setSelectionRange(start, end);
        onChange?.(e);
      }
    : onChange;

  return (
    <input
      type={type}
      className={cn(
        "flex h-7 w-full rounded-md border border-input bg-transparent dark:bg-white/[0.04] px-2 py-0.5 text-[13px] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-xs file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        shouldUppercase && "uppercase",
        className
      )}
      ref={ref}
      onWheel={handleWheel}
      onFocus={handleFocus}
      onChange={handleChange}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
